// extracted by mini-css-extract-plugin
export var cartSec = "Topheader-module--cartSec--e8583";
export var cart_icon = "Topheader-module--cart_icon--5812a";
export var closeSec = "Topheader-module--closeSec--ced9e";
export var communityBtn = "Topheader-module--communityBtn--02768";
export var dropdownToggle = "Topheader-module--dropdown-toggle--020ea";
export var logo = "Topheader-module--logo--97109";
export var mobMenu = "Topheader-module--mobMenu--67be7";
export var mobileMenu = "Topheader-module--mobileMenu--1e09b";
export var navLink = "Topheader-module--nav-link--64c77";
export var profileImg = "Topheader-module--profileImg--a4013";
export var spansec = "Topheader-module--spansec--d0207";
export var titleSec = "Topheader-module--titleSec--aea49";
export var topnamesec = "Topheader-module--topnamesec--a7458";
export var topsec = "Topheader-module--topsec--b49ec";
export var userDropmenu = "Topheader-module--userDropmenu--69926";